import ExportSidebar from "./ProSideBar";
import { Link } from 'react-router-dom';
import { PageHeader } from "./AuxiliaryFunctions";
import { useDispatch, useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux";
import CompetenciaDataService from "./services/competencia.service";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import './index.css';
import { IoMdBuild } from "react-icons/io";
import * as FaIcons from "react-icons/fa";
import { Col, Container, FormLabel, FormControl, Button, Row, Alert } from "react-bootstrap";
import CompetenciasList from "./CompetenciasList";
import NoPrivileges from "./NoPrivileges";
import { logout } from "./actions/auth";

const Competencias = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  // Superadmin role is id = 4
  /*
  return (
    (currentUser.roles.includes(4))?(<CompetenciasAuth />):
    <>
      <NoPrivileges currentUser={currentUser}/>
    </>
  )
  */
  return (
    <CompetenciasAuth />
  )
}

const CompetenciasAuth = () => {
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);	
  const [status, setStatus] = useState(0);
  const [primernombre, setPrimernombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [SortType, setSortType] = useState('DESC');
  const [SortField, setSortField] = useState('fechainicio');
  const [CompetenciaFilterByDescr, setCompetenciaFilterByDescr] = useState('');
  const [listOfCompetencias, setlistOfCompetencias] = useState([]);
  

  const onChangeSortType = () => {
    setSortType(SortType == 'DESC'?'ASC':'DESC');
  }

  const onChangeSortField = (e) => {
    setSortField(e.target.value);
  }

  const onChangeCompetenciaFilterByDescr = (e) => {
    setCompetenciaFilterByDescr(e.target.value);
  }  

  useEffect(() => {
    performSearch(CompetenciaFilterByDescr,SortField,SortType);
  },[CompetenciaFilterByDescr,SortField,SortType]);

  const performSearch = (descr,sortfield,sorttype) => {
    CompetenciaDataService.getCompetenciaByDescr("", descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        setlistOfCompetencias(response.data);
      })
      .catch(e => {
        if (e.status === 401) {
          dispatch(logout());
        }
      });
  };

  useEffect(() => {
    
    UserDataService.get(currentUser.id)
    .then(
      (response) => { 
        //console.log(response);
        //console.log(currentUser);
        setPrimernombre(response.data[0].primernombre);
        setprimerapellido(response.data[0].primerapellido);
        setStatus(response.data[0].habilitado);
        //performSearch(SortType,SortField,CompetenciaFilterByDescr);
      }
    )
    .catch((e) => {
      if (e.response.status == 401) {
        console.log("status 401");
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
      }
      console.log(e.response);
    });  
    
  }, []);

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
        <Container>
        <PageHeader />                
          {(status === 1) && 
            <>            
              <Row className='mb-2 d-flex'>
                <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Competencias</h5>

                <Col lg={true}>
                  <FormLabel className='mb-2'>Filtrar por nombre:</FormLabel>       
                  <FormControl type="text" name="filterbycompetencia" id="filterbycompetencia" onChange={onChangeCompetenciaFilterByDescr}></FormControl>
                </Col>

                <Col lg={true}>
                  <FormLabel className='mb-2'>Ordenar por:</FormLabel>       
                  <FormControl as='select' onChange={onChangeSortField}>
                    <option value="id">ID competencia</option>
                    <option value="nombrecompetencia">Nombre competencia</option>
                    <option value="createdAt">Fecha creación</option>                    
                    <option value="fechainicio">Fecha de inicio</option>    
                  </FormControl>
                </Col>
              
                <Col sm={true}>
                  <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                  <FormControl style={{maxWidth:"50px"}} as="button" onClick={onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
                </Col>                 

              </Row>

              {(currentUser.roles.includes(4) || currentUser.roles.includes(3)) &&
              <>
              <Link to="/new-competencia" className="mr-2 btn btn-secondary">Nueva Competencia</Link>            
              <Button className="m-2 btn btn-secondary">Exportar</Button>        
              </>
              }

              <Alert>
                Confirma disponibilidad para tener más oportunidades de ser asignado a una competencia. 
                Si confirmaste disponibilidad para una competencia y ahora ves un ícono de advertencia es porque un administrador cambió las fechas de la competencia y deberás confirmar disponibilidad nuevamente.
              </Alert>              

              <Row>
                <CompetenciasList mode={0} listOfCompetencias = {listOfCompetencias} />      
              </Row>            

            </>
          }
          {(status === 0) && 
            <>
            <div className="main-frame-page">          
              <h5>Tu perfil aun no ha sido habilitado por un administrador.</h5>
              <div style={{backgroundColor:'', padding:'10px'}}>
                Cuando tu perfil esté habilitado tendrás acceso a más opciones en la plataforma!
              </div>
            </div>
            </>
          }    
        </Container>      
      </div>
    </>
  )
};
  
export default Competencias;